export const DELIVERY_TEAMS_ROUTE = '/delivery-teams';

export const wfmNodePath = (nodeId) => `${DELIVERY_TEAMS_ROUTE}/nodes/${encodeURIComponent(nodeId)}`;

export const wfmTeamPath = (teamId) => `${DELIVERY_TEAMS_ROUTE}/teams/${encodeURIComponent(teamId)}`;

export const wfmRowPath = (node) => (node.is_leaf ? wfmTeamPath(node.node_id) : wfmNodePath(node.node_id));

export const rankAllTeamsPath = () => `${DELIVERY_TEAMS_ROUTE}?tab=team&focus=table`;
